import styled from 'styled-components';

export const ContainerProducedRate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 4px;
  height: inherit;
  border-right: 1px solid var(--allie-color-neutral-20);
  background-color: var(--allie-color-light-main);
`;
